"use strict";
/*
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Graphics2D = void 0;
const Font_1 = require("../graphics2d/Font");
const FontMetrics_1 = require("../graphics2d/FontMetrics");
/**
 *
 *
 */
class Graphics2D {
    _font;
    _fontMetrics;
    _fontRenderContext;
    constructor() {
        this._font = new Font_1.Font("arial", 10, 10);
        this._fontMetrics = new FontMetrics_1.FontMetrics(this._font);
    }
    setFont(value) {
        this._font = value;
        this._fontMetrics = new FontMetrics_1.FontMetrics(this._font);
    }
    getFont() {
        return this._font;
    }
    setFontMetrics(value) {
        this._fontMetrics = value;
    }
    getFontMetrics() {
        return this._fontMetrics;
    }
    setColor(color) {
        //return;
    }
    setBackground(color) {
        //return;
    }
    setTransform(id) {
        //return;
    }
    getTransform() {
        return null;
    }
    setStroke(stroke) {
        //return;
    }
    drawLine(x1, y1, x2, y2) {
        //return;
    }
    dispose() {
        //return;
    }
    rotate(theta, x, y) {
        //return;
    }
    clearRect(x, y, width, height) {
        //return;
    }
    drawString(s, x, y) {
        //return;
    }
    getFontRenderContext() {
        return this._fontRenderContext;
    }
}
exports.Graphics2D = Graphics2D;
//# sourceMappingURL=Graphics2D.js.map